import React from "react";
import { useTranslation } from "react-i18next";
import { EmployerTabs } from "../../components/employer/EmployerTabs";
import { AccountSettings } from "../../components/AccountSettings";

export default function EmployerAccount() {
  const { t } = useTranslation();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-heading text-3xl font-bold text-stone-text mb-6">{t("account.pageTitle")}</h1>
      <EmployerTabs />
      <div className="mt-6">
        <AccountSettings />
      </div>
    </div>
  );
}
